import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';

export const useDeleteDeclarantLogo = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (declarantId: string) => {
      await request({
        path: `declarant/${declarantId}/logo`,
        method: 'DELETE',
        authenticate: true,
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin-declarants'] });
      toast.success('Declarant logo deleted successfully!');
    },
    onError: (error) => {
      showErrorToast(error, 'Error deleting declarant logo!');
    },
  });
};
